const ITEM_SIZE_UNITS = {
    SMART: 'SMART',
    PIXEL: 'PIXEL',
    PERCENT: 'PERCENT',
};
export default ITEM_SIZE_UNITS;
//# sourceMappingURL=layoutParams_targetItemSize_unit.js.map